import React from 'react'
import {Box, Divider, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";

const Footer = (props) => {
    return (
        <footer className="s-footer" style={{position: 'relative'}}>
            <Box sx={{ py: 1, px: 10 }}>
               
                <Grid container>
                    <Grid item lg={4}>
                        
                        <Typography fontWeight={'bold'} sx={{mb:3}}>Gene Conquer 2025</Typography>
                        <Typography>Purely Classic Conquer Online 1.0 features that we all love. The nostalgia feeling where a little hard
                            work goes a long way.The real mean of PK over DragonBall.</Typography>

                        

                    </Grid>
                   
                    <Grid item lg={4}>
                        
                    </Grid>
                  
                    <Grid item lg={4}>
                       
                        <Typography fontWeight={'bold'} sx={{mb:3}}>Disclaimer</Typography>

                        <Typography>Gene Conquer is NOT related on TQ Digital or any Server.</Typography>

                       
                       

                    </Grid>
                </Grid>
            </Box>
        </footer>
    )
}

export default Footer
